import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function doPendingWork(accountId: string): Promise<void> {
  try {
    await axios.post(`/accounts/${accountId}/status/doPendingWork`);
  } catch (error) {
    throwSylaApiError(error);
  }
}
